module.exports = __webpack_public_path__ + "img/logo-whatsapp.39ec5b8d.png";